import { render, staticRenderFns } from "./AppNotificationsDrawer.vue?vue&type=template&id=59cc0a5c&"
import script from "./AppNotificationsDrawer.vue?vue&type=script&lang=js&"
export * from "./AppNotificationsDrawer.vue?vue&type=script&lang=js&"
import style0 from "./AppNotificationsDrawer.vue?vue&type=style&index=0&id=59cc0a5c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports